// GuestAuth.js
import React, { useEffect, useState } from 'react';
import { auth } from '../firebase'; // Ensure you import your Firebase initialized auth instance
import { onAuthStateChanged, signInAnonymously } from 'firebase/auth';

const GuestAuth = ({ children }) => {
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    // Listen for auth state changes
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // User is signed in (can be anonymous or regular)
        setUserId(user.uid);
      } else {
        // No user found – sign in anonymously
        try {
          const result = await signInAnonymously(auth);
          setUserId(result.user.uid);
        } catch (error) {
          console.error("Error signing in anonymously:", error);
        }
      }
    });
    return () => unsubscribe();
  }, []);

  // Pass the guest user ID (or use context) to children components
  return React.cloneElement(children, { userId });
};

export default GuestAuth;
